/**
 * @Description 点位评测
 */
import { post } from '@/common/request/index';

/**
 * 点位评测详情
 */
export function spotEvaluationDetail(params: any) {
  return post('/spot/evaluation/detail', { ...params });
}

/**
 * 点位评测概要
 */
export function spotEvaluationOverview(params: any) {
  return post('/spot/evaluation/overview', { ...params });
}

/**
 * 经营门店tab
 */
export function spotEvaluationLevelCount(params: any) {
  return post('/spot/evaluation/levelCount', { ...params });
}

/**
 * 经营门店明细
 * https://yapi.lanhanba.com/project/349/interface/api/75333
 */
export function spotEvaluationLevelPage(params: any, config?: any) {
  return post('/spot/evaluation/levelPage', { ...params }, config);
}

/**
 * 知名品牌门店分页列表
 * https://yapi.lanhanba.com/project/349/interface/api/73191
 */
export function famousBrandDataList(params: any, config?: any) {
  return post('/spot/evaluation/famous/brand/page', { ...params }, config);
}

/**
 * 竞品品牌分页接口
 * https://yapi.lanhanba.com/project/511/interface/api/73345
 */
export function surroundCompetitorsPagePOIDataList(params: any, config?: any) {
  return post('/spot/evaluation/competitorsPage', { ...params }, config);
}

/**
 * 点位评测图例
 */
export function spotEvaluationLegend(params: any) {
  return post('/spot/evaluation/legend', { ...params });
}

/**
 * 客流画像
 */
export function spotEvaluationPopulation(params: any) {
  return post('/spot/evaluation/population', { ...params });
}

/**
 * 周边配套 tab接口（返回一二级tab及对应数量）
 * https://yapi.lanhanba.com/project/349/interface/api/75438
 */
export function spotEvaluationAroundCategory(params: any) {
  return post('/spot/evaluation/arroundCategory', { ...params });
}

/**
 * 周边配套 poi分页列表
 */
export function spotEvaluationSurround(params: any) {
  return post('/spot/evaluation/surround', { ...params });
}

/**
 * 查询历史
 */
export function spotEvaluationHistory(params: any) {
  return post('/spot/evaluation/record/page', { ...params });
}

/**
 * 查询半径经纬度
 */
export function spotEvaluationModel() {
  return post('/spot/evaluation/model', {});
}

/**
 * 根据经纬度获得poi名称
 * https://yapi.lanhanba.com/project/469/interface/api/75172
 */
export function getTargetPOIInfo(params?: any) {
  return post('/amap/location', { ...params }, {
    // isMock: true,
    needHint: true,
    needCancel: false,
    isFlowV2: true
  });
}

/**
 * 1207周边查询接口替换
 * poi分页列表
 * https://yapi.lanhanba.com/project/511/interface/api/64973
 */

export function getSpotEvaluationAroundPage(params:any, config?: any) {
  return post(`/spot/evaluation/arroundPage`, params, config);
}


// =======================分享接口=======================
/**
 * 点位评测详情
 */
export function spotEvaluationDetailShare(params: any) {
  return post('/spot/evaluation/share/detail', { ...params });
}

/**
 * 点位评测概要
 */
export function spotEvaluationOverviewShare(params: any) {
  return post('/spot/evaluation/share/overview', { ...params });
}

/**
 * 经营门店tab
 */
export function spotEvaluationLevelCountShare(params: any) {
  return post('/spot/evaluation/share/levelCount', { ...params });
}

/**
 * 经营门店明细
 * https://yapi.lanhanba.com/project/349/interface/api/75333
 */
export function spotEvaluationLevelPageShare(params: any, config?: any) {
  return post('/spot/evaluation/share/levelPage', { ...params }, config);
}

/**
 * 点位评测图例
 */
export function spotEvaluationLegendShare(params: any) {
  return post('/spot/evaluation/share/legend', { ...params });
}

/**
 * 客流画像
 */
export function spotEvaluationPopulationShare(params: any) {
  return post('/spot/evaluation/share/population', { ...params });
}

/**
 * 周边配套 tab接口（返回一二级tab及对应数量）
 * https://yapi.lanhanba.com/project/349/interface/api/75438
 */
export function spotEvaluationAroundCategoryShare(params: any) {
  return post('/spot/evaluation/share/arroundCategory', { ...params });
}

/**
 * 周边配套 poi分页列表
 */
export function spotEvaluationSurroundShare(params: any) {
  return post('/spot/evaluation/share/surround', { ...params });
}

/**
 * 知名品牌门店分页列表
 * https://yapi.lanhanba.com/project/349/interface/api/73191
 */
export function famousBrandDataListShare(params: any, config?: any) {
  return post('/spot/evaluation/share/famous/brand/page', { ...params }, config);
}

/**
 * 竞品品牌分页接口
 * https://yapi.lanhanba.com/project/511/interface/api/73345
 */
export function surroundCompetitorsPagePOIDataListShare(params: any, config?: any) {
  return post('/spot/evaluation/share/competitorsPage', { ...params }, config);
}

/**
 * 1207周边查询接口替换
 * poi分页列表
 * https://yapi.lanhanba.com/project/511/interface/api/64973
 */

export function getSpotEvaluationAroundPageShare(params:any, config?: any) {
  return post(`/spot/evaluation/share/arroundPage`, params, config);
}

/**
 * 点位评测生成查询记录（找雪飞，暂无文档）
 */
export function saveRecord(params: any) {
  return post('/spot/evaluation/saveRecord', { ...params });
}

/**
 * 点位评测商场类型选择
 * https://yapi.lanhanba.com/project/349/interface/api/77538
 */
export function getMallShopList(params: any) {
  return post('/spot/evaluation/mallShop/pageList', { ...params });
}
